export const FundingProcessorTypes = Object.freeze({
    DEMOCRACY_ENGINE: 'de',
    ACT_BLUE: 'actblue',
    NONE: 'none',
});